<template lang="pug">
.sp-container
    .s-photo-list.row
        .view-photo(:class="containerCss" v-for="item in pipes")
            .gp-box.load(v-for="(img,imgKey) in item " :id="'imgBox' + img.id")
                .loading
                    span
                    span
                    span
                a( :href="img.url" target="_blank" :class=" 'img-item-' + (imgKey%2) ")
                    img( v-lazy="isSupWebP? img.imgUrl + '.webp' : img.imgUrl" :alt="img.name")
                .tools(v-if="uiShowTool")
                    .like
                        .do-box(@dblclick="editorReview(img.id,$event)")
                            span.like-act(@click="unlike(img.id,$event)")
                                i.fa.fa-thumbs-o-down
                            span.like-act(@click="like(img.id,$event)")
                                i.fa.fa-heart.do-like
                        .do-box.do-comment(@click="showComment(img.id,$event)")
                            i.fa.fa-comments
                            span.text(v-if="img.commentsCount>0") {{img.commentsCount}}
                        .do-load(v-if="uiShowCommentLoad.indexOf(img.id)>-1")
                            i.fa.fa-spinner.fa-spin.fa-fw
                    .comment-box(v-if="uiShowComment.indexOf(img.id)>-1")
                        .post-comment.row
                            .col-8
                                textarea(:placeholder="LANG.leaveAComment" :id="'cmtPost'+img.id")
                            .col-4
                                button.btn.btn-success(@click="postComment(img.id)")  {{LANG.postComment}}
                        Comment(:id="img.id" @loaded="commentLoaded" :refresh="refreshComments")
                        .close-cmt-list(@click="closeCommentList(img.id)")
                            i.fa.fa-angle-double-up
                            span {{LANG.hideComment}}
        .last-page(v-if="reachedLastPage")
            a(:href=" '?' + query + '&page=' + page") {{LANG.nextPage}}
        .msg.is-last(v-if="reachedLast") {{message}}
</template>
<script>
    /**
     * Google image seo :
     * @url https://support.google.com/webmasters/answer/114016?hl=en
     */
    import VueLazyload from 'vue-lazyload'
    import Vue from 'vue'
    import util from "../lib/util"
    import $ from "jquery"
    import Comment from "../components/Comment";
    /**/
    Vue.use(VueLazyload, {
        preLoad: 1.3,
        error: 'dist/error.png',
        attempt: 1,
        adapter: {
            loaded(obj) {
                $(obj.el).parents('.gp-box').find('.loading').hide();
                $(obj.el).parents('.gp-box').removeClass('load');
            }
        }
    });

    export default {
        name: 'GlobalPhotoList',
        components : {
            Comment
        },
        data() {
            return {
                photoList : window.vueCfg.dataList,
                pageCfg : window.vueCfg.pageCfg,
                query : window.vueCfg.query || "",
                LANG : window.LANG,

                message : window.LANG.reachedLast,
                reachedLast : false,
                reachedLastPage :false,
                defaultLastPage : 5,
                pipes : [
                    [],[]
                ],
                page : window.vueCfg.curPage || 1,       //服务端页码
                pageCounter : 1,    //前端当前页码计数器
                isLoading : false,
                isMobile : util.isMobile(),
                oneColumn : false,
                imgWidthAuto : false,
                containerCss : '',

                dbCommentsList : [],
                uiShowTool : true,
                uiShowComment :[],
                uiShowCommentLoad : [],
                isSupWebP : util.isSupWebP(),

                refreshComments : []
            }
        },
        beforeMount : function(){
            let mThis = this;

            if ( this.pageCfg.pipes > 1 ){
                this.pipes = [
                    [] ,[]
                ];
            } else {
                this.pipes = [[]];
            }
            if ( this.isMobile ){
                this.pipes = [[]];
            }
            if ( this.pageCfg.uiShowTool === false){
                this.uiShowTool = this.pageCfg.uiShowTool;
            }

            this.defaultLastPage = this.pageCfg.pageMax || this.defaultLastPage;
            if ( this.page <= 0 ){
                this.page = 1;
            }

            util.scrollBottom(function(){
                // console.log('reach last!!');
            },function(h){

                //star page
                let padding = $('.js-listpage-padding').height();
                let paading = parseInt(padding);
                if ( isNaN(padding) ){
                    padding = 0;
                }
                if (padding == 0){
                    if ( h < 800){
                        mThis.loadNext();
                    }
                } else {
                    if ( h < padding * 2 ){
                        mThis.loadNext();
                    }
                }
            });

            this.containerCss = this.getCss();

            if (this.pageCfg.photoId){
                this.postHits(this.pageCfg.photoId);
            } else if (this.pageCfg.sid){
                this.postHits(this.pageCfg.sid,true);
            }
            this.render();
            this.photoReview();
            //check html PostComment element on page
            if ($('.js-post-cmt').length > 0){

                document.onkeydown = function(event) {
                    if (event.ctrlKey && event.keyCode == 13) {
                        mThis.postComment(mThis.pageCfg.photoId);
                    }
                }
                $('.js-post-cmt-btn').click(function(){
                    mThis.postComment(mThis.pageCfg.photoId);
                });
            }

            //record the view time duration
            if ( mThis.pageCfg.photoId ){

                var interval = Math.ceil(Math.random()*15);
                if ( interval <= 8 ){
                    interval = 8;
                }
                var times = 0;
                window.recordTimer = setInterval(function(){
                    //"/photos/record/?pid=" + mThis.pageCfg.photoId + "&rType=stay&time=" + interval
                    $.getJSON(`/photos/record/?pid=${mThis.pageCfg.photoId}&rType=stay&time=${interval}&r=`+Math.random())
                    times++;
                    if ( times >= 10 ){
                        clearInterval(window.recordTimer);
                    }
                }, 1000 * interval);
                console.log(interval);
            }
        },
        methods : {
            postHits : function(id , isStar ){
                if (isStar === true){
                    $.getJSON("/star/postHits/?sid="+id+"&r=" + Math.random());
                } else {
                    $.getJSON("/photos/postHits/?pid="+id+"&r=" + Math.random());
                }
            },
            photoReview : function(){
                var mThis = this;
                $('.reviews .review').hover(function(){
                    var me = $(this).attr('star');
                    for(var x=1;x<=parseInt(me);x++){
                        $('.review'+x).addClass('hover');
                    }
                },function(){
                    $('.review').removeClass('hover');
                }).click(function(){
                    //$this->validate("level:intval&notempty;pid:intval&notempty;sid:intval");
                    var me = $(this).attr('star');
                    $('.reviews').html(mThis.LANG.thanksForReview);
                    $.getJSON("/photos/review/?pid=" + window.vueCfg.pageCfg.photoId+`&sid=${window.vueCfg.pageCfg.sid}&level=${me}`);
                });
            },

            getCss : function(){
                var retCss = [];
                if ( this.pipes.length > 1 ){
                    retCss.push('pipe img-w-100');
                    retCss.push('col-6');
                }
                return retCss.join(' ');
            },
            goUrlNext : function(){
                location.href = "?page=" + this.page;
            },

            computeCss : function(){
                var tplCss = [];
                if (util.isMobile() || this.pageCfg.oneColumn){
                    this.pipes = [ [] ];
                    //this.containerCss += "w-100 one-column";
                    tplCss.push("w-100");
                } else {
                    //this.containerCss += "col-6";
                    tplCss.push("col-6");
                }

                if (!util.isMobile()){
                    //this.containerCss += " img-auto";
                    tplCss.push("img-auto");
                } else {
                    this.containerCss += " img-w-100";
                    tplCss.push("img-w-100");
                }

                if (this.pipes.length >= 2){
                    tplCss = util.removeItemFromArray(tplCss , "img-auto");
                    tplCss.push("img-w-100");
                }
                return tplCss.join(" ");
            },
            render : function(){
                var curPip = 0;
                var tmpPip = this.pipes;
                console.log(this.photoList);
                for(var x in this.photoList ){
                    this.pipes[curPip].push( this.photoList[x] );
                    curPip++;
                    if (curPip >= this.pipes.length){
                        curPip = 0;
                    }
                }
                this.isLoading = false;
            },

            like : function( id , event ){
                $.getJSON("/photos/doLike/?ajax=1&pid=" + id);
                $(event.currentTarget).find('.do-like').addClass('liked');
            } ,
            unlike : function( id , event ){
                $.getJSON("/photos/doLike/?ajax=1&type=unlike&pid=" + id);
                //$(event.currentTarget).find('.do-like').addClass('liked');
                $('#imgBox'+id).hide('fast');
            } ,
            editorReview : function(id , event){
                $('#imgBox'+id).find('.loading').show();
                $.getJSON("/photos/editorReview/?ajax=1&pid=" + id,function(){
                    $('#imgBox'+id).find('.loading').hide();
                });
            },
            closeCommentList : function(id){
                this.uiShowComment = util.removeItemFromArray(this.uiShowComment , id);
            },
            commentLoaded : function(data){
                this.uiShowCommentLoad = util.removeItemFromArray(this.uiShowCommentLoad , data.id);
            },
            postComment : function(id){
                $.post("/photos/comment/?ajax=1",{
                    pid : id,
                    content : $('#cmtPost'+id).val()
                },function(data){
                    alert(data.msg);
                    $('#cmtPost'+id).val('');
                },'JSON');
                this.refreshComments.push(id);
            },
            showComment : function(id){
                if ( this.uiShowComment.indexOf(id) > -1 ){
                    this.uiShowComment = util.removeItemFromArray(this.uiShowComment , id);
                } else {
                    this.uiShowComment.push(id);
                    this.uiShowCommentLoad.push(id);
                }
            },
            loadNext : function(){
                let mThis=  this;

                if (this.isLoading || this.reachedLast){
                    return;
                }
                this.page ++;
                this.pageCounter ++;
                this.isLoading = true;
                if ( this.pageCounter >= this.defaultLastPage ){
                    this.reachedLastPage = true;
                    return;
                }

                let apiUrl = `/star/getList/?ajax=1&sid=${this.pageCfg.sid}`;
                if ( typeof this.pageCfg.nextUrl != 'undefined'){
                    apiUrl = this.pageCfg.nextUrl;
                }

                $.getJSON(`${apiUrl}&${mThis.query}&page=${this.page}`,function(data){

                    if (data.errorCode != 0){
                        mThis.isLoading = false;
                        return;
                    }

                    if (data.msg.restart == true){
                        mThis.page = data.msg.pages.curPage;
                    }

                    if (data.msg.list.length <= 0){
                        mThis.reachedLast = true;
                        mThis.isLoading = false;
                        return;
                    }

                    mThis.photoList = data.msg.list;
                    mThis.render();
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/GlobalPhotoList.vue